import { useEffect, useState } from "react";
import { Megaphone, Warning, Siren, X } from "@phosphor-icons/react";
import { listAnnouncements, dismissAnnouncement } from "../lib/api";
import { relativeTime } from "../lib/theme";

export const LEVELS = {
  info: { label: "Info", color: "#0A84FF", Icon: Megaphone },
  warning: { label: "Warning", color: "#FF9F0A", Icon: Warning },
  urgent: { label: "Urgent", color: "#FF453A", Icon: Siren },
};

export default function Announcements() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    listAnnouncements().then(setItems).catch(() => {});
  }, []);

  if (!items.length) return null;
  const dismiss = (id) => {
    setItems((xs) => xs.filter((x) => x.id !== id));
    dismissAnnouncement(id).catch(() => {});
  };

  return (
    <div className="space-y-3 mb-8" data-testid="announcements">
      {items.map((a) => {
        const l = LEVELS[a.level] || LEVELS.info;
        return (
          <div key={a.id} data-testid={`announcement-${a.id}`} data-level={a.level}
            className="relative overflow-hidden rounded-3xl bg-card p-5 pr-14 flex gap-4 items-start shadow-[0_1px_2px_rgba(0,0,0,0.04),0_10px_30px_-18px_rgba(0,0,0,0.2)] animate-in fade-in slide-in-from-top-2 duration-500">
            <span aria-hidden className="absolute inset-0 opacity-[0.06] dark:opacity-[0.14]" style={{ background: l.color }} />
            <span className="relative h-10 w-10 rounded-2xl flex items-center justify-center shrink-0" style={{ background: `${l.color}1F`, color: l.color }}>
              <l.Icon weight="duotone" className="h-5 w-5" />
            </span>
            <div className="relative min-w-0">
              <p className="text-[11px] uppercase tracking-[0.16em] font-semibold" style={{ color: l.color }}>
                {l.label} · from {a.author_name || "Admin"} · {relativeTime(a.created_at)}
              </p>
              <p className="mt-1 text-base font-semibold tracking-tight" data-testid={`announcement-title-${a.id}`}>{a.title}</p>
              {a.message && <p className="mt-1 text-sm text-muted-foreground leading-relaxed whitespace-pre-line">{a.message}</p>}
            </div>
            <button type="button" aria-label="Dismiss announcement" data-testid={`dismiss-announcement-${a.id}`} onClick={() => dismiss(a.id)}
              className="absolute top-4 right-4 h-8 w-8 rounded-full flex items-center justify-center text-muted-foreground hover:bg-muted hover:text-foreground transition-colors">
              <X className="h-4 w-4" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
